<h2>Qr code</h2>
<div class="card">
  @if (!searchText.disabled) {
  <div class="input-icon">
    <input
      type="text"
      class="form-control"
      placeholder="Buscar"
      [formControl]="searchText"
    />
    <img src="assets/svg/search.svg" alt="search" />

    @if (searchText.value) {
    <div class="units">
      @if(loadUnits){
      <p class="empty-item">Carregando...</p>
      } @if(!units.length && !loadUnits){
      <p class="empty-item">
        Não existe unidades com as informações do filtro.
      </p>
      } @for (item of units; track $index) {
      <p class="unit-item" (click)="selectUnit(item)">
        CR{{ item.code }} - {{ item.name }}
      </p>
      }
    </div>
    }
  </div>
  }

  <p class="description">
    Veja as opções disponíveis de QrCodes para a unidade
  </p>
  <p class="sub-description">
    Clique na imagem e faça o download do QrCode ideal para a unidade.
  </p>

  @if (unit) {
  <p class="sub-description">CR {{ unit.code }} - {{ unit.name }}</p>

  <div class="docs">
    @for (item of documentList; track $index) {
    <div class="doc" (click)="downloadImageWithQrCode(item)">
      <img
        [ngClass]="{ horizontal: item.horizontal }"
        [src]="'assets/docs/' + item.urlSmallImg"
        [alt]="item.url"
        [title]="item.url"
        width="100%"
      />
      <div class="info">
        <p>{{ item.name }}</p>
      </div>
    </div>
    }
  </div>

  <p>Quantidade disponível: {{ documentList.length }}</p>

  } @else {
  <div class="empty">
    <p>Nenhuma unidade selecionada no momento</p>
  </div>
  }
</div>
